module.exports = __webpack_public_path__ + "img/mapa_clientes.f72b974d.jpeg";